const calculateImageSliderBoundaries = (totalResults: number, currentSlideIndex: number) => {
    const firstSlide = currentSlideIndex > 3 ? currentSlideIndex - 3 : Math.max(0, currentSlideIndex - 3);
    const lastSlide = currentSlideIndex < totalResults - 3 ? currentSlideIndex + 3 : totalResults - 1;
    return { firstSlide, lastSlide };
  };
  export default calculateImageSliderBoundaries;
